import * as React from 'react';
import styles from './Dashboard.module.scss';

export default function Dashboard() {
  return (
    <div className={styles.dashboard}>
        Medicube
    </div>
  );
}